import { NavLink, useLocation } from "react-router-dom";
import InboxService from "../Services/InboxService";
import { useEffect, useState } from "react";
import InboxThreadRow from './InboxThreadRow';
import moment from 'moment';
import TagService from "../Services/TagService";

function InboxGeneral({ loading, emails, page, setPage }) {

    const [count, setCount] = useState(0);
    const [syncing, setSyncing] = useState(false);
    const location = useLocation();
    const [selectedAccount, setSelectedAccount] = useState('');
    const [lastRowClicked, setLastRowClicked] = useState(null);


    useEffect(() => {
        const saved = sessionStorage.getItem('lastRowClicked');
        if (saved) {
            setLastRowClicked(Number(saved));
        }
        TagService.loadTagsInCache();
        getThreadsCountForInbox();
    }, []);

    useEffect(() => {
        getThreadsCountForInbox();
    }, [selectedAccount]);


    useEffect(() => {
        getAccountFromQueryParams();
    }, [location.search])

    async function getThreadsCountForInbox() {
        let { count } = await InboxService.getThreadCountForInbox('', selectedAccount);
        setCount(count);
    }

    function getAccountFromQueryParams() {
        let params = new URLSearchParams(location.search);
        let account = params.get('account');
        setSelectedAccount(account || '');
    }

    function incrementPage() {
        if (isLastPage()) return;
        setPage(page + 1);
    }

    function isLastPage() {
        let pages = Math.ceil(count / 10);
        return page === pages;
    }

    function decrementPage() {
        if (page === 1) return;
        setPage(page - 1);
    }

    async function syncThreadsFromGmail() {
        setSyncing(true);
        try {
            if (selectedAccount) {
                let { message } = await InboxService.syncThreadsFromGmailByAccount(selectedAccount);
            } else {
                let { message } = await InboxService.syncThreadsFromGmail();
            }

            const checkStatus = async () => {
                let { syncing } = await InboxService.getSyncStatus();
                if (!syncing) {
                    clearInterval(intervalId);
                    setSyncing(false);
                    getThreadsCountForInbox();
                    setPage(1);
                }
            };

            let intervalId = setInterval(checkStatus, 5000);
            await checkStatus();

        } catch (err) {
            console.error(err);
            setSyncing(false);
        }
    }

    function renderEmailRow(email, i) {

        return <InboxThreadRow email={email}
            key={email._id || i}
            row={i}
            onClick={(row) => sessionStorage.setItem('lastRowClicked', row)}
            lastRowClicked={lastRowClicked} />
    }

    let firstMessage = emails[0];

    let last_sync_at = '';

    if (firstMessage) {
        last_sync_at = moment(firstMessage.last_sync_at).format('ll LTS');
    }


    return (
        <div>
            {(loading || syncing) && (
                <div className="loading-overlay">
                    <div className="spinner-container">
                        <i className="fa-solid fa-spin fa-spinner"></i>
                        <span>{loading ? 'Loading...' : 'Syncing...'}</span>
                    </div>
                </div>
            )}
            <div className='inbox-email-header'>
                <div
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Select"
                    className="inbox-email-checkbox">
                    <input className="form-check-input"
                        type="checkbox" id={`inbox-email-checkbox`} value={true} />
                </div>

                <button
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Sync messages from gmail"
                    disabled={loading || syncing}
                    onClick={syncThreadsFromGmail}
                    className="inbox-button">
                    <i className="fa-solid fa-rotate-right"></i>
                </button>

                <button
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="More"
                    className="inbox-button">
                    <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>


                <div
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content={`Last sync at ${last_sync_at} (${moment(last_sync_at).fromNow()})`}
                    className="fs-12 ml-auto text-muted me-3">
                    Last sync <i className="fa-solid fa-sync ms-1 me-2"></i>
                </div>

                <div className='fs-12  me-3'>
                    {InboxService.normalizePaginationText(page, count)}
                </div>

                <button
                    onClick={decrementPage}
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Newer"
                    className="inbox-button">
                    <i className="fa-solid fa-chevron-left"></i>
                </button>

                <button
                    onClick={incrementPage}
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Older"
                    disabled={isLastPage()}
                    className="inbox-button">
                    <i className="fa-solid fa-chevron-right"></i>
                </button>


            </div>
            <div className="inbox-email-rows">
                <div className="list-group" style={{ position: 'relative', width: "100%" }}>
                    {emails.map((email, i) => (renderEmailRow(email, i)))}
                </div>
            </div>
        </div>
    )

}

export default InboxGeneral;